var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"color":"bg_card"}},[_c('v-card-title',[_vm._v("リンク")]),_c('v-card-text',[_c('v-data-table',{attrs:{"dense":"","loading":_vm.loading,"headers":_vm.headers,"items":_vm.items,"options":_vm.options},scopedSlots:_vm._u([{key:"item.url",fn:function(ref){
var item = ref.item;
return [_c('a',{attrs:{"target":"_blank","href":item.url}},[_vm._v(" "+_vm._s(item.url)+" ")])]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }